import { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { EpFormInput } from '../EpFormInput';
import { EpStepContent } from '../EpStepContent';

// import QuestionsInputsParams from '../../Forms/IncidentNotification/QuestionsInputsParams';

type QuestionsAnswersProps = {
  id: number;
  questionId: number;
  questionDescription: string;
  required: boolean;
  maxLength: number;
  questionReferLibraryId: number;
  questionTypeId: number;
  questionsLibrary: boolean;
  questionCategoryIncident: number;
  order: number;
  answerRequiredId: number | null;
  questionRequiredId: number | null;
  answers: {
    answerId: number;
    answerDescription: string;
  }[];
};

const EpQuestionText = ({
  QuestionsAnswers,
  index,
  translations,
}: {
  QuestionsAnswers: QuestionsAnswersProps;
  index: number;
  translations?: string[];
}) => {

  const { formState: { errors } } = useFormContext();

  return (
    <EpStepContent.Label
      key={QuestionsAnswers.id}
      label={`${QuestionsAnswers.questionDescription}  ${QuestionsAnswers.required ? '*' : ''}`}
      required={QuestionsAnswers.required}
    >
      <EpFormInput
        key={QuestionsAnswers.id}
        type="text"
        inputName={`questions.${index}.inputValue` as const}
        inputRequired={QuestionsAnswers.required}
        maxLength={QuestionsAnswers.maxLength}
        inputWithError={errors && errors?.questions && !!Object.values(errors?.questions)[index]}
        //@TODO - Gustavo, precisei comentar pois naõ achei solução para o errro do build.
        // {...(QuestionsInputsParams[QuestionsAnswers.questionId] && QuestionsInputsParams[QuestionsAnswers.questionId].AddonLeftText && { inputAddonLeftText: QuestionsInputsParams[QuestionsAnswers.questionId].AddonLeftText })}
        // {...(QuestionsInputsParams[QuestionsAnswers.questionId] && QuestionsInputsParams[QuestionsAnswers.questionId].AddonRightText && { inputAddonRightText: QuestionsInputsParams[QuestionsAnswers.questionId].AddonRightText })}
        translations={translations}
      />
    </EpStepContent.Label>
  );
};

export default memo(EpQuestionText);
